
import image1 from "../../assets/Images/iraqMusuem.webp";
import image2 from "../../assets/Images/Choman.jpeg";
import image3 from "../../assets/Images/marshes2.jpeg";



const imageSlide = [
	{
		url: image1,
		title:
			"Discover one of the most charming places you will ever see!",
	},
	{
		url: image2,
		title:
			"اكتشف أحد أجمل الأماكن التي ستراها على الإطلاق!",
	},
	{
		url: image3,
		title: "هەناردنەوی یەکەم لە خولەکێندن!",
	},
];

export default imageSlide;
